import { combineReducers } from '@reduxjs/toolkit';
import meSlice from './me.slice';
import authSlice from './auth.slice';
import companySlice from './company.slice';
import bankAccountsSlice from './bankAccountsSlice';
import invoiceSlice from './invoiceSlice';
import tourSlice from './tour.slice';
import inventoryFilterSlice from './inventoryFilters.slice'

const rootReducer = combineReducers({
    me: meSlice,
    auth: authSlice,
    company: companySlice,
    bank: bankAccountsSlice,
    invoice: invoiceSlice,
    tours: tourSlice,
    inventoryFilter: inventoryFilterSlice
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
